<template>
  <v-app-bar fixed app color="#93dcff" flat id="sticky-header" v-if="display">
    <v-toolbar-items class="pl-5">
      <v-layout  align-center justify-center>
        <p class="mb-0 users-text">
          Mis usuarios asignados ({{user_count}})
        </p>
  

        <p class="mb-0 ml-2 contacted-text">
          {{contacted_count}} USUARIOS CONTACTADOS
        </p>
      </v-layout>

    </v-toolbar-items>

    <v-spacer></v-spacer>

    <v-toolbar-items class="pl-5">
      <v-layout  align-center justify-center>
        <span class="instruction-text mr-2">
          <i>
              Se actualizarán todos los datos introducidos y se cargará un nuevo listado de 10 usuarios.
          </i>
        </span>
  

        <v-btn dense class="app-button" id="request-new-users" color="primary"
        @click="$emit('request')">
        GUARDAR LISTADO</v-btn>
      </v-layout>

    </v-toolbar-items>

  </v-app-bar>
</template>

<script>
  export default {
    name: 'AppBar',

    props: {
      user_count: {
        type: Number,
        default: 0
      },
      contacted_count: {
        type: Number,
        default: 0
      },
      display: {
        type: Boolean,
        default: false
      }
    },

    computed: {

    },

    methods: {

    },
  }
</script>

<style scoped lang="scss">

  #sticky-header {

    .users-text {
      color: #222c38;
      font-size: 1.2rem;
    }

    .instruction-text {
      color: #246c8e;
      font-size: 0.9rem;
      max-width: 272px;
    }

    .contacted-text {
      color: #404a57;
      font-size: 1.125rem;
    }
  
  }
  
</style>